import React, {useEffect} from 'react';
import {Button, Drawer, TextField} from "@mui/material";
import FunctionsData from "../../../Functions/FunctionsData";

export default function LandingCommunityLogsUpdateRedeemed({ row,setLoading, setOpen,setRefreshTrigger }) {

    const [state, setState] = React.useState({...row});
    const [valid, setValid] = React.useState([]);
    useEffect(() => {
        if(row) setState({...row})
    }, [row])

    function updateValue(col,val) {
        setState({...state, [col]:val});
    }

    function submitData() {

        FunctionsData.postData(
            '/api/orders/order/' + row.order_id,
            {
                first: state.owner_first,
                last: state.owner_last,
                email: state.email,
                phone: state.phone,
            }
        )
            .then(() => {
                FunctionsData.postData(
                    '/api/voucher/update/' + row.id,
                    {
                        a_name: state.a_name,
                        a_type: state.a_type,
                        a_gender:state.a_gender
                    }
                )
                    .then(() => {
                        setLoading(true);
                        setOpen(false);
                        setLoading(false);
                        setRefreshTrigger(prev => !prev);
                    })
                    .catch((e) => {
                        console.log(e);
                    })
            })
            .catch((e) => {
                setLoading(true);
                setOpen(false);
                setLoading(false);
                setRefreshTrigger(prev => !prev);
            })

    }

    return (
        <div style={{width:'100%'}}>

            <h1 style={{marginBottom:20}}>{row?.sn}</h1>

            <ShowText col={'owner_first'} label={'First name'} row={state} updateValue={updateValue} valid={valid} setValid={setValid} />
            <ShowText col={'owner_last'} label={'Last name'} row={state} updateValue={updateValue} valid={valid} setValid={setValid} />
            <ShowText col={'email'} label={'Email'} row={state} updateValue={updateValue} valid={valid} setValid={setValid} />
            <ShowText col={'phone'} label={'Phone'} row={state} updateValue={updateValue} valid={valid} setValid={setValid} />

            <h3 style={{margin:'20px 0'}}>Animal details</h3>

            <ShowText col={'a_type'} label={'Animal type'} row={state} updateValue={updateValue} allow={['Dog','Cat']} valid={valid} setValid={setValid} />
            <ShowText col={'a_gender'} label={'Animal sex'} row={state} updateValue={updateValue} allow={['Male','Female']} valid={valid} setValid={setValid} />

            <div>
                <Button disabled={valid.filter((v) => v.value === false).length > 0} variant={"contained"} onClick={submitData}>Submit</Button>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
            </div>

        </div>
    )

}

function ShowText({col, label, row, updateValue, allow, valid, setValid, disabled}) {

    if(!valid.find((v) => v.slug === col)) {
        setValid([...valid, {slug:col, value:row[col] !== '' || (allow && !allow.includes(row[col]))}])
    }

    return (
        <div style={{marginBottom: !allow ? 20 : null}}>
            <TextField error={row[col] === '' || (allow && !allow.includes(row[col]))}
                       value={row[col]}
                       disabled={disabled}
                       onChange={(e) => {
                           updateValue(col, e.target.value);
                           let valCopy = valid.filter((v) => v.slug !== col);
                           setValid([...valCopy, {slug:col, value: e.target.value !== '' && (!allow || allow.includes(e.target.value))}])
                       }}
                       label={label} fullWidth />
            {
                allow &&
                <div style={{fontSize:'0.7em', marginBottom:20}}>Allowed values: {allow.join(', ')}</div>
            }
        </div>
    )
}
